import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=f542451e&scoped=true&lang=pug&"
var script = {}
import style0 from "./cell.vue?vue&type=style&index=0&id=f542451e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f542451e",
  null
  
)

export default component.exports